import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";

export interface IDragAndDropProps {
  onChange: (img: any) => void;
}

const DragAndDrop: React.FC<IDragAndDropProps> = (props) => {
  let { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      props.onChange(acceptedFiles);
    }
  }, [acceptedFiles]);

  return (
    <div {...getRootProps({ className: "dropzone" })}>
      <input
        id="appIcon"
        type="text"
        {...getInputProps()}
        className="fileUpload"
        hidden={true}
      />
      <div className="dropZoneOverlay pointer">
        <p>
          DRAG IMAGE HERE OR <span>BROWSE</span>
        </p>
        <p className="small-text">MAX size 5 MB</p>
      </div>
    </div>
  );
};

export default DragAndDrop;
